import React from "react";
import PropTypes from "prop-types";
import DropdownCustom from "../DropdownCustom";
import FieldWrapper from "./FieldWrapper";
import MultiSelectDropdown from "./MultiSelectDropdown";

export const DropdownField = ({
  label,
  error,
  helperText,
  fullWidth,
  required,
  options,
  value,
  onChange,
  multiSelect = false,
  showDLR,
  ...props
}) => {
  const selectedOption = multiSelect
    ? value || null
    : options.find((option) => option.value === value) || null;

  return (
    <FieldWrapper
      label={label}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      required={required}
    >
      {multiSelect ? (
        <>
          <MultiSelectDropdown
            options={options}
            onSelectionChange={onChange}
            selectVal={selectedOption}
            error={!!error}
            showDLR={showDLR}
            {...props}
          />
        </>
      ) : (
        <>
          <DropdownCustom
            selectOpts={options}
            onChange={onChange}
            selectVal={selectedOption}
            error={!!error}
            containerStyle={{ width: "auto", margin: "1px" }}
            {...props}
          />
        </>
      )}
    </FieldWrapper>
  );
};

DropdownField.propTypes = {
  ...FieldWrapper.propTypes,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default DropdownField;
